<template>
  <div class="blur-container d-flex align-center justify-center flex-column">
    <mf-icon :icon="blurIcon" color="marca-0" size="24" fill />
    <p class="mb-0 mt-2">{{ blurCaption }}</p>
  </div>
</template>

<script>
export default {
  name: 'BlurCard',
  props: {
    blurCaption: {
      type: String,
      default: 'Sem permissão de acesso',
    },
    blurIcon: {
      type: String,
      default: 'lock',
    },
  },
}
</script>

<style lang="scss" scoped>
.blur-container {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: transparent;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(6px);
    z-index: 1;
  }

  p {
    position: relative;
    z-index: 2;
    font-weight: 500;
    color: $marca-0;
    font-size: 16px;
    text-align: center;
  }

  span {
    position: relative;
    z-index: 2;
  }
}
</style>
